import { render, staticRenderFns } from "./menuWrapper_en.vue?vue&type=template&id=2e58b301&"
import script from "./menuWrapper_en.vue?vue&type=script&lang=js&"
export * from "./menuWrapper_en.vue?vue&type=script&lang=js&"
import style0 from "./menuWrapper_en.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports